import { useParams } from "../../Providers/ParamsProvider"

const NavigationSection = ({ currentStage, setCurrentState }) => {
    const { isMobile } = useParams()
    if (isMobile) {
        return (
            <div className="row my-3 align-items-center" style={{ paddingBottom: '30px' }}>
                <div className="col-auto position-relative" onClick={() => setCurrentState(1)}>
                    <div className={`circle ${currentStage === 1 ? 'currentStage' : ''}`}>1</div>
                    <div className="step-label-mobile mobile-font ">Koszyk</div>
                </div>
                <div className="col">
                    <hr />
                </div>
                <div className="col-auto position-relative" onClick={() => setCurrentState(2)}>
                    <div className={`circle ${currentStage === 2 ? 'currentStage' : ''}`}>2</div>
                    <div className="step-label-mobile mobile-font">Dostawa i płatność</div>
                </div>
                <div className="col">
                    <hr />
                </div>
                <div className="col-auto position-relative" onClick={() => setCurrentState(3)}>
                    <div className={`circle ${currentStage === 3 ? 'currentStage' : ''}`}>3</div>
                    <div className="step-label-mobile mobile-font">Podsumowanie</div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className='col-auto my-5'>
                <div className='row'>
                    <div className='col-auto' onClick={() => setCurrentState(1)}>
                        <div className='row align-items-center'>
                            <div className={`col-auto circle ${currentStage === 1 ? 'currentStage' : ''} `}>1</div>
                            <div className={`col-auto circle-text ${currentStage === 1 ? 'currentStage-text' : ''} `}>Koszyk</div>
                            <div className='col-auto line'></div>
                        </div>
                    </div>

                    <div className='col-auto' onClick={() => setCurrentState(2)}>
                        <div className='row align-items-center'>
                            <div className={`col-auto circle ${currentStage === 2 ? 'currentStage' : ''}`}>2</div>
                            <div className={`col-auto circle-text ${currentStage === 2 ? 'currentStage-text' : ''}`}>Dostawa i płatność</div>
                            <div className='col-auto line'></div>
                        </div>
                    </div>

                    <div className='col-auto' onClick={() => setCurrentState(3)}>
                        <div className='row align-items-center'>
                            <div className={`col-auto circle ${currentStage === 3 ? 'currentStage' : ''}`}>3</div>
                            <div className={`col circle-text ${currentStage === 3 ? 'currentStage-text' : ''}`}>Podsumowanie</div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default NavigationSection